import { render, staticRenderFns } from "./ViewReportForm.vue?vue&type=template&id=62428a2a&scoped=true"
import script from "./ViewReportForm.vue?vue&type=script&lang=js"
export * from "./ViewReportForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62428a2a",
  null
  
)

export default component.exports